const colorsMapping = {
  letterColor1: '#DE4B9B',
  letterColor2: '#00B3B3',
  letterColor3: '#8873FF',
  letterColor4: '#2894D1',
  letterColor5: '#F1B334',
  letterColor6: '#FF986C',
  letterColor7: '#64BEFF',
  letterColor8: '#5873FF',
  letterColor9: '#FF6694',
  letterColor10: '#27B772',
  letterColor11: '#CF866F',
  letterColor12: '#FF932F'
};
const letterColorMapping = {
  a: colorsMapping.letterColor1,
  b: colorsMapping.letterColor2,
  c: colorsMapping.letterColor3,
  d: colorsMapping.letterColor4,
  e: colorsMapping.letterColor5,
  f: colorsMapping.letterColor6,
  g: colorsMapping.letterColor7,
  h: colorsMapping.letterColor8,
  i: colorsMapping.letterColor9,
  j: colorsMapping.letterColor10,
  k: colorsMapping.letterColor11,
  l: colorsMapping.letterColor12,
  m: colorsMapping.letterColor1,
  n: colorsMapping.letterColor2,
  o: colorsMapping.letterColor3,
  p: colorsMapping.letterColor4,
  q: colorsMapping.letterColor5,
  r: colorsMapping.letterColor6,
  s: colorsMapping.letterColor7,
  t: colorsMapping.letterColor8,
  u: colorsMapping.letterColor9,
  v: colorsMapping.letterColor10,
  w: colorsMapping.letterColor11,
  x: colorsMapping.letterColor12,
  y: colorsMapping.letterColor1,
  z: colorsMapping.letterColor2
};

export default letterColorMapping;
